export default __webpack_public_path__ + "static/media/avatar_tommy_pyper5.4d07d7c4.mp3";